import { RootState } from '@redux/store'

export const payoffDisplaySettleTypeSelector = ({ payoff }: RootState) =>
  payoff.displaySettleType

export const payoffSelector = ({ payoff }: RootState) => payoff.payoff

export const payoffTransactionsSelector = ({ payoff }: RootState) =>
  payoff.transactions
